module.exports = __webpack_public_path__ + "img/GN.cbeb23fa.svg";